<template>
  <div class="adp-p adp-dd-option flex-jcsb-aic" @mouseover="$emit('mouseover')">
    <b-form-checkbox v-model="competence.isChecked" :indeterminate="competence.isIndeterminate" @change="onChange($event)">
      {{ competence[`name_${$i18n.locale}`] }}
    </b-form-checkbox>
    <span v-show="competence.children && competence.children.length"> > </span>
  </div>
</template>

<script>

export default {
  name: 'MyTreeFilterNode',
  props: {
    competence: {
      required: true
    },
  },
  data() {
    return {};
  },
  watch: {
    'competence.isChecked': function (newVal) {
      this.onChange(newVal);
    },
  },
  methods: {
    onChange(isChecked) {
      let data = {
        isChecked: isChecked,
      }
      this.$emit('my-node-change', data);
    },
  },
}
</script>

<style scoped>
  .flex-jcsb-aic {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
</style>
